import { useQueryClient } from "@tanstack/react-query"

import { OrderChatDrawer } from "../../../../../../../shared/components/orderChat/OrderChatDrawer"
import { ChatMessageAuthorRole, UserType } from "../../../../../../../shared/components/orderChat/orderChatTypes"
import { UserMeetingsReceipt } from "../../../../../../nonAdminUser/reports/MeetingsReceipt/UserMeetingsReceipt"
import { useMerchant } from "../../../../../../merchants/merchantHooks"
import { useAppSelector } from "../../../../../../store/storeHooks"
import { selectEffectiveUserId } from "../../../../../../context/contextSelectors"
import { MerchantMeetingServiceOrdersQuery } from "../../meetingServiceApi"
import { MeetingServiceOrder } from "../../meetingServiceTypes"
import { OrderPackageSlip } from "../../components/OrderPackageSlip"

type Props = Readonly<{
    order: MeetingServiceOrder
    showReceipt: boolean
    onCloseReceipt: () => void
    showChat: boolean
    onCloseChat: () => void
    showPackingSlip: boolean
    onClosePackingSlip: () => void
}>

export function ProductionOrderCardOverlays({
    order,
    showReceipt,
    onCloseReceipt,
    showChat,
    onCloseChat,
    showPackingSlip,
    onClosePackingSlip,
}: Props) {
    const { merchantId } = useMerchant()
    const userId = useAppSelector(selectEffectiveUserId)
    const queryClient = useQueryClient()

    return (
        <>
            {showReceipt && (
                <UserMeetingsReceipt
                    open={showReceipt}
                    onClose={onCloseReceipt}
                    singleMode
                    meetings={[order]}
                    id={order.id}
                />
            )}

            {showChat && (
                <OrderChatDrawer
                    open
                    onClose={onCloseChat}
                    orderId={order.id}
                    orderTitle={order.meetingDetails?.meetingName}
                    viewerRole={ChatMessageAuthorRole.MERCHANT}
                    sender={userId ? { type: UserType.MERCHANT, merchantId, userId } : undefined}
                    onMessageSent={() =>
                        queryClient.invalidateQueries({
                            queryKey: [MerchantMeetingServiceOrdersQuery.MEETING_SERVICE],
                        })
                    }
                />
            )}

            {showPackingSlip && (
                <OrderPackageSlip
                    open
                    onClose={onClosePackingSlip}
                    orders={[order]}
                    orderIds={[order.id]}
                    merchantId={merchantId}
                />
            )}
        </>
    )
}
